import React from 'react';
type ProductBonus = {
  title: string;
  tagline: string;
  image: string;
  alt: string;
  bullets: string[];
};
const bonuses: ProductBonus[] = [{
  title: 'BONUS 1 — KIT DE REGULACIÓN EMOCIONAL',
  tagline: 'Para acompañar emociones en el aula inclusiva.',
  image: 'https://cdn.magicpatterns.com/uploads/suiiA8Jz5dZUPHJJ8jGr3U/bonus_1.png',
  alt: 'Kit de Regulación Emocional',
  bullets: ['emociones', 'respiración', 'pausas activas', 'estrategias de calma']
}, {
  title: 'BONUS 2 — TABLEROS VISUALES Y APOYOS',
  tagline: 'Estructura visual para organizar el día.',
  image: 'https://cdn.magicpatterns.com/uploads/t9eMViaV1k62kiRwURcuMF/bonus_2.png',
  alt: 'Tableros Visuales y Apoyos',
  bullets: ['rutinas visuales', 'horarios adaptados', 'normas del aula', 'agenda visual']
}, {
  title: 'BONUS 3 — ATENCIÓN, MEMORIA Y FOCO',
  tagline: 'Para fortalecer funciones ejecutivas.',
  image: 'https://cdn.magicpatterns.com/uploads/nzt3WHyAXvDjvdhaHPomN8/bonus_3.png',
  alt: 'Atención, Memoria y Foco',
  bullets: ['atención visual', 'memoria secuencial', 'patrones', 'búsqueda visual']
}, {
  title: 'BONUS 4 — CUADERNO DE AUTONOMÍA',
  tagline: 'Independencia y organización personal.',
  image: 'https://cdn.magicpatterns.com/uploads/jU6FFWo55AEZnzuZHEs8Ua/bonus_4.png',
  alt: 'Cuaderno de Autonomía',
  bullets: ['rutinas del hogar', 'hábitos escolares', 'autocuidado', 'manejo del tiempo']
}, {
  title: 'BONUS 5 — PLANIFICADOR DOCENTE INCLUSIVO',
  tagline: 'Herramienta profesional para tu día a día.',
  image: 'https://cdn.magicpatterns.com/uploads/s31AyJbsvauz5ywT76Cfj2/bonus_5.png',
  alt: 'Planificador Docente Inclusivo',
  bullets: ['seguimiento del alumno', 'objetivos personalizados', 'planificación semanal', 'evaluación adaptada']
}];
const premiumBonuses: ProductBonus[] = [{
  title: 'BONUS PREMIUM — JUEGOS PEDAGÓGICOS INCLUSIVOS',
  tagline: 'Aprender jugando. Visual y dinámico.',
  image: 'https://cdn.magicpatterns.com/uploads/iU8WJ3iUF2FF4L9rrsTVYm/bonus_6.png',
  alt: 'Juegos Pedagógicos Inclusivos',
  bullets: ['memotest y dominós', 'secuencias y lógica', 'recortables y tarjetas', 'juegos imprimibles']
}, {
  title: 'BONUS PREMIUM — TALLER DE ALIMENTACIÓN SALUDABLE',
  tagline: 'Actividades visuales para desarrollar autonomía.',
  image: 'https://cdn.magicpatterns.com/uploads/fjhdVKj7kQ5pzpco7QyYgm/BONUS_PREMIUM_—_TALLER_DE_ALIMENTACION_SALUDABLE.png',
  alt: 'Taller de Alimentación Saludable',
  bullets: ['preparación de alimentos', 'compras y supermercado', 'higiene y hábitos', 'fotografías reales']
}, {
  title: 'BONUS PREMIUM — PAUSAS ACTIVAS Y REGULACIÓN EN EL AULA',
  tagline: 'Recursos visuales para favorecer el bienestar y la atención.',
  image: 'https://cdn.magicpatterns.com/uploads/kQLnvwZTuAee3MfMV1FYv2/BONUS_PREMIUM_—_PAUSAS_ACTIVAS.png',
  alt: 'Pausas Activas y Regulación en el Aula',
  bullets: ['pausas activas guiadas', 'estrategias de autorregulación', 'movimiento y calma', 'material visual listo']
}, {
  title: 'BONUS PREMIUM — CUADERNILLO DE MATEMÁTICA PARA DISCALCULIA',
  tagline: 'Actividades visuales y progresivas para fortalecer el razonamiento matemático.',
  image: 'https://cdn.magicpatterns.com/uploads/wLZfkkoPyMQW4PRCXxs5Tz/2037146a-e02f-42c5-b8df-674e9063b673.png',
  alt: 'Cuadernillo de Matemática para Discalculia',
  bullets: ['sentido numérico', 'cálculo paso a paso', 'resolución de problemas', 'material visual adaptado']
}];
function BonusCard({
  bonus,
  premium,
  reverse
}: {
  bonus: ProductBonus;
  premium?: boolean;
  reverse?: boolean;
}) {
  const palette = premium ? 'bg-yellow-50 border-2 border-yellow-400 shadow-lg' : 'bg-gray-50 border border-gray-200';
  const heading = premium ? 'text-yellow-600' : 'text-blue-600';
  const check = premium ? 'text-yellow-600' : 'text-green-600';
  return <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-6 rounded-3xl p-6 ${palette}`} data-id="element-32" data-mp="30jac9jubkwo7">
      <div className="w-full md:w-1/2 flex justify-center" data-id="element-33" data-mp="20brxh8sh9i9">
        <img src={bonus.image} alt={bonus.alt} className="w-[340px] h-[340px] object-contain drop-shadow-xl" data-id="element-34" data-mp="3t87hal9iswz0" />
      </div>
      <div className="w-full md:w-1/2" data-id="element-35" data-mp="3o70aaof7c1te">
        <h3 className={`text-2xl md:text-3xl font-black mb-2 ${heading}`} data-id="element-36" data-mp="3ja0auwcuxxb9">
          {premium ? '👑' : '🎁'} {bonus.title}
        </h3>
        <p className="text-lg text-gray-700 mb-4" data-id="element-37" data-mp="2cuh9b3fa5ok3">{bonus.tagline}</p>
        <ul className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-base text-gray-800" data-id="element-38" data-mp="27u3bsfbb1x0b">
          {bonus.bullets.map(item => <li key={item} className="flex items-center" data-id="element-39" data-mp="ndvgp17ejq0p">
              <span className={`${check} mr-2 font-bold`} data-id="element-40" data-mp="sbdsczct0jce">✔</span>
              {item}
            </li>)}
        </ul>
      </div>
    </div>;
}
export function BonusSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-41" data-mp="1216tt7j8fi2x">
      <div className="max-w-5xl mx-auto" data-id="element-42" data-mp="1231eqlui7a70">
        <div className="text-center mb-8" data-id="element-43" data-mp="170jpmhs2zzhn">
          <h2 className="text-[20px] font-black mb-3 text-[#F9327E]" data-id="element-44" data-mp="16zru16yhi1rd">
            Además recibís 5 bonus + 4 bonus premium
          </h2>
          <div className="inline-block bg-red-600 text-white text-base md:text-lg font-black px-6 py-2 rounded-full shadow-lg animate-bounce" data-id="element-45" data-mp="1b47vmw12en0s">
            🎁 GRATIS POR HOY
          </div>
        </div>

        <div className="space-y-8" data-id="element-46" data-mp="1kxylo5cub5il">
          {bonuses.map((bonus, index) => <BonusCard key={bonus.title} bonus={bonus} reverse={index % 2 === 1} data-id="element-47" data-mp="3hufi6jp9kdfd" data-mpi={index} />)}

          {premiumBonuses.map((bonus, index) => <BonusCard key={bonus.title} bonus={bonus} premium reverse={index % 2 === 0} data-id="element-48" data-mp="3er9n6536liq7" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}